'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _icomoon = require('./fonts/icomoon');

var _icomoon2 = _interopRequireDefault(_icomoon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//

var dom = weex.requireModule('dom');


var COLMO_ICONFONT_NAME = 'dolphinColmoFont';

if (!weex.config.env.isInit && dom && dom.addRule) {
  dom.addRule('fontFace', {
    fontFamily: COLMO_ICONFONT_NAME,
    // eslint-disable-next-line
    src: "url('" + _icomoon2.default + "')"
    // src: "url('https://dolphin-weex-dev.msmartlife.cn/static/component/font/icomoon.ttf')"
  });
  weex.config.env.isInit = true;
}

exports.default = {
  mixins: [_colmo2.default],
  props: {
    code: {
      default: '\u4705',
      type: String
    },
    size: {
      default: 32,
      type: Number
    },
    color: {
      default: 'rgba(255, 255, 255, 0.8)',
      type: String
    },
    iconStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    fontFamily: {
      type: String,
      default: COLMO_ICONFONT_NAME
    }
  },
  data: function data() {
    return {
      isInit: weex.config.env.isInit === true || false
    };
  },

  watch: {
    _theme: function _theme() {
      this.initFontFamily();
    }
  },
  created: function created() {
    this.initFontFamily();
  },

  computed: {
    mergeStyle: function mergeStyle() {
      var iconStyle = this.iconStyle,
          size = this.size,
          color = this.color,
          fontFamily = this.fontFamily;

      var fontSize = size + 'px';
      return _extends({
        fontFamily: fontFamily,
        fontSize: fontSize,
        color: color
      }, iconStyle);
    }
  },
  methods: {
    itemClicked: function itemClicked() {
      this.$emit('dofIconFontClicked');
    },
    initFontFamily: function initFontFamily() {
      if (this._theme === 'colmo' && !weex.config.env.isInit) {
        //
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-iconfont/index.vue
// module id = 342
// module chunks = 0 1